import { call, put, takeLatest, all } from 'redux-saga/effects';
import axios from 'axios';
import { showMessage } from 'app/store/actions/fuse';
import * as Actions from '../../actions';

function* fetchAllClients() {
	try {
		const response = yield call(() => axios.get('/api/v1/clients'));
		yield put(Actions.fetchAllClientsSuccess(response.data));
	} catch (error) {
		yield put(Actions.fetchAllClientsFailure());

		yield put(
			showMessage({
				message: 'Unable to Retrieve Clients',
				variant: 'error'
			})
		);
	}
}

function* deleteClients(action) {
	const { clientIds } = action.payload;
	try {
		yield call(() => axios.patch('/api/v1/clients?clientPatchOperation=Delete', clientIds));
		yield put(Actions.deleteClientsSuccess());

		yield put(Actions.fetchAllClients());

		yield put(
			showMessage({
				message: 'Clients Deleted',
				variant: 'success'
			})
		);
	} catch (error) {
		yield put(Actions.deleteClientsFailure());

		yield put(
			showMessage({
				message: 'Unable to Delete Clients',
				variant: 'error'
			})
		);
	}
}

function* toggleClientsEnabled(action) {
	const { clientIds } = action.payload;

	try {
		yield call(() => axios.patch('/api/v1/clients?clientPatchOperation=ToggleEnabled', clientIds));
		yield put(Actions.toggleClientsEnabledSuccess());

		yield put(Actions.fetchAllClients());

		yield put(
			showMessage({
				message: "Clients' Enabled Status Updated",
				variant: 'success'
			})
		);
	} catch (error) {
		yield put(Actions.toggleClientsEnabledFailure());

		yield put(
			showMessage({
				message: "Unable to Toggle Clients' enabled status",
				variant: 'error'
			})
		);
	}
}

function* watchClients() {
	yield all([
		yield takeLatest(Actions.fetchAllClients, fetchAllClients),
		yield takeLatest(Actions.deleteClients, deleteClients),
		yield takeLatest(Actions.toggleClientsEnabled, toggleClientsEnabled)
	]);
}

export default watchClients;
